export const NONE = 'None';

export const DEFAULT_FIRST_QUARTER_MONTH_END = 3;
export const DEFAULT_SECOND_QUARTER_MONTH_END = 6;
export const DEFAULT_THIRD_QUARTER_MONTH_END = 9;
export const DEFAULT_FOURTH_QUARTER_MONTH_END = 12;

export const DEFAULT_QUARTERS_MONTH_ENDS = [
  DEFAULT_FIRST_QUARTER_MONTH_END,
  DEFAULT_SECOND_QUARTER_MONTH_END,
  DEFAULT_THIRD_QUARTER_MONTH_END,
  DEFAULT_FOURTH_QUARTER_MONTH_END,
];

export const COMPANIES_LOADING_MESSAGE =
  'Loading companies and their measurement dates. You can continue once they are loaded.';
export const COMPANIES_LOAD_FAILED_MESSAGE =
  'Companies could not be loaded, so no measurement date can be created. Retry, or close the dialog and try again later.';
export const ROLLOVER_FAILED_MESSAGE =
  'This may not have been created. Refresh the page to check, and contact Scalar if it is still missing.';
